export default __webpack_public_path__ + "static/media/trabalhar_03.14cb905c.jpg";